import { render, staticRenderFns } from "./GraduatePlacementAssignmentModal.vue?vue&type=template&id=92564128&"
import script from "./GraduatePlacementAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./GraduatePlacementAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports